import dateFormatLib from "date-fns/format";
import moment from "moment-timezone";

export const ISIS_FORMAT = {
  date: "yyyy-MM-DD",
  time: "HH:mm"
};

export function getDate(UTCString) {
  if (!UTCString) return "";
  return UTCString.replace(/T.*$/, "");
}

export function getTimeString(time, timezone, format) {
  return moment(time)
    .tz(timezone || "Etc/UTC")
    .format(format);
}

export function addDayOfDate(date, dayAdding, format) {
  return moment(date)
    .add(dayAdding, "days")
    .format(format || ISIS_FORMAT.date);
}

export function subtractDayOfDate(date, daySubstract, format) {
  return moment(date)
    .subtract(daySubstract, "days")
    .format(format || ISIS_FORMAT.date);
}

export function formatDate(time, format) {
  // refers: https://date-fns.org/v2.22.1/docs/format

  try {
    if (!time) return "";
    if (time instanceof Date) {
      return dateFormatLib(time, format);
    }
    // type of time is: string, number,...
    return dateFormatLib(new Date(time), format);
  } catch (error) {
    return "";
  }
}

export function isSameDate(firstTime, secondTime) {
  return moment(firstTime).isSame(secondTime, "day");
}

export const formatDateClient =
  localStorage.getItem("language") === "en"
    ? "MM-DD-YYYY HH:mm"
    : "DD-MM-YYYY HH:mm";

export function convertDateFromServer(date, type) {
  // range date: [startDate, endDate]
  if (type === "date-range") {
    if (!date.length) return [];

    const startDate = moment(date[0]).format(formatDateClient);
    const endDate = moment(date[1]).format(formatDateClient);
    return [startDate, endDate];
  }

  if (type === "date") {
    if (!date) return "";

    return moment(date).format(formatDateClient);
  }

  if (type === "date-time") {
    if (!date) return "";
    return moment(date, "YYYY-MM-DD HH:mm").format(formatDateClient + " HH:mm");
  }
}

export function convertDateSendServer(date, type) {
  // range date: [startDate, endDate]
  if (type === "date-range") {
    const startDate = moment(date[0], formatDateClient).format("YYYY-MM-DD");
    const endDate = moment(date[1], formatDateClient).format("YYYY-MM-DD");
    return [startDate, endDate];
  }

  if (type === "date") {
    return moment(date, formatDateClient).format("YYYY-MM-DD");
  }

  if (type === "date-time") {
    return moment(date, formatDateClient + " HH:mm").format("YYYY-MM-DD HH:mm");
  }
}

export const convertTimeByTimezone = (
  sourceTime,
  sourceTimezone,
  targetTimezone,
  formatTarget
) => {
  if (!sourceTime) return "";
  const start = moment.tz(sourceTime, sourceTimezone);
  return start.tz(targetTimezone).format(formatTarget);
};
